import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { AuthService } from "../services/auth.service";

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) { }

	canActivate(): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
		if(this.router.url.startsWith('/auth')) {
			return true;
		}

		return this.authService.checkToken().pipe(
			tap((isAuthenticated) => {
				if (!isAuthenticated) {
					this.router.navigate(['/auth/login'], { queryParams: { redirect: this.router.url } });
				}
			})
		);
	}
}